import React from 'react';

import InfoPill from 'components/application/pills/InfoPill';

import InfoIcon from '-!svg-react-loader?name=InfoIcon!icons/info.svg';

export default function LearnMoreInfoPill() {
  return (
    <InfoPill
      className='tw-bg-teal-025 tw-text-teal-700'
      icon={
        <InfoIcon
          className='tw-mr-1.5 [&_path]:tw-fill-teal-700'
          height={12}
          width={12}
        />
      }
      text={
        <div className='tw-text-xs tw-font-semibold tw-tracking-wide'>
          Learn more
        </div>
      }
    />
  );
}
